import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt alle Grabarten zurück.
 */
export function getGraveTypes(): JQueryPromise<modelsGet.IGraveType[]>
{
    var endpoint = new URI("api/gravetypes");
    return api.get<modelsGet.IGraveType[]>({
        endpoint: endpoint.href()
    });
}

export function getGraveTypesPaging(pageNo: number, pageSize: number): JQueryPromise<modelsGet.IPagedResult<modelsGet.IGraveType>>
{
    var endpoint = new URI("api/gravetypes");
    if (pageNo != null)
        endpoint.setQuery("pageNo", pageNo.toString());

    if (pageSize != null)
        endpoint.setQuery("pageSize", pageSize.toString());

    return api.get<modelsGet.IPagedResult<modelsGet.IGraveType>>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine bestimmte Grabart zurück.
 */
export function getGraveTypesById(id: number): JQueryPromise<modelsGet.IGraveType>
{
    var endpoint = new URI("api/gravetypes");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IGraveType>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Grabarten die mit einem bestimmten Kalender verbunden sind, zurück.
 */
export function getGraveTypesByCalendarId(calendarId: number): JQueryPromise<modelsGet.IGraveType[]>
{
    var endpoint = new URI("api/gravetypes/calendars");
    endpoint.segment(calendarId.toString());

    return api.get<modelsGet.IGraveType[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Grabarten die mit einem bestimmten Friedhof verbunden sind, zurück.
 */
export function getGraveTypesByCementeryId(calendarId: number): JQueryPromise<modelsGet.IGraveType[]>
{
    var endpoint = new URI("api/gravetypes/cementeries");
    endpoint.segment(calendarId.toString());

    return api.get<modelsGet.IGraveType[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(graveType: modelsPost.IGraveType): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/gravetypes/create",
        data: JSON.stringify(graveType)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, graveType: modelsPost.IGraveType): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/gravetypes/edit/${id}`,
        data: JSON.stringify(graveType)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/gravetypes/delete/${id}`
    });
}